import { render, staticRenderFns } from "./POStatusTimeline.vue?vue&type=template&id=562be673&scoped=true"
import script from "./POStatusTimeline.vue?vue&type=script&lang=ts"
export * from "./POStatusTimeline.vue?vue&type=script&lang=ts"
import style0 from "./POStatusTimeline.vue?vue&type=style&index=0&id=562be673&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562be673",
  null
  
)

export default component.exports